import styled from '@emotion/styled';

export const Container = styled.form`
	display: flex;
	flex-direction: column;
	gap: 4.8rem;
	max-width: 44rem;
	width: 100%;
	margin: 0 auto;
	margin-top: calc(${(props) => props.theme.heights.header} + 8rem);
	margin-bottom: 8rem;
	@media screen and (max-width: ${(props) => props.theme.breakpoints.layout}px) {
		margin-top: calc(${(props) => props.theme.heights.headerMobile} + 8rem);
		padding: 0 2rem;
	}
	.title {
		font-size: ${(props) => props.theme.fontSize.size4xl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: 130%;
		letter-spacing: -0.6px;
	}
`;

export const FieldBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
`;

export const Button = styled.button`
	width: 100%;
	padding: 1.4rem 1.2rem;
	border: none;
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	cursor: pointer;
`;

export const MenuBox = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.8rem;
`;

export const MenuButton = styled.button`
	background-color: transparent;
	border: none;
	color: #868e96;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	cursor: pointer;
`;

export const PhoneBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;

export const PhoneWrapper = styled.div`
	display: flex;
	gap: 0.8rem;
	width: 100%;
`;

export const SendButton = styled.button`
	width: 8rem;
	height: 4.4rem;
	vertical-align: middle;
	text-align: center;
	background-color: #212529;
	color: #fff;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
`;
